module.exports = __webpack_public_path__ + "static/img/smartPitch.5c34b584.svg";